import { IToastOptionsData } from '../../config/interfaces';

/**
 * Store sub context for toast data
 */
const ToastContext = {
  hidden: true,
  options: {} as IToastOptionsData,
  slide: 'hide',
  type: ''
};

export default ToastContext;
